import * as Sentry from '@sentry/browser';
import { DRIVER_COUNT_THRESHOLD } from '../constants';

export class DriverCountExceededException extends Error {
  constructor(public readonly driverCount: number, public readonly organizationUuid?: string) {
    super('Driver count exceeded the allowed threshold');
  }
}

// TODO: Logic in checking threshold is temporary until we support pagination
export const captureDriverCountWarning = (driverCount: number, organizationUuid?: string) => {
  if (driverCount > DRIVER_COUNT_THRESHOLD) {
    const exception = new DriverCountExceededException(driverCount, organizationUuid);
    Sentry.captureMessage(exception.message, { level: 'warning', extra: { driverCount, organizationUuid } });
  }
};
